exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".cart-remove-promo-modal[data-v-5acc8a92] {\n  padding-top: 1.5em;\n  padding-bottom: 2.5em;\n}\n.cart-remove-promo-modal .mr-btn[data-v-5acc8a92] {\n  display: inline-block;\n  vertical-align: top;\n  width: 14em;\n}\n@media only screen and (min-width: 0px) and (max-width: 559px) {\n.cart-remove-promo-modal .mr-btn[data-v-5acc8a92] {\n    width: 9.5em;\n}\n}\n", ""]);

// exports
